import { formatDateISO8601 as m } from "@amenitiz/design-system";
import { PaymentType as d } from "./index232.mjs";
import { calculateTotalPrice as l } from "./index111.mjs";
import { filterObject as c } from "./index233.mjs";
import { getABoostValue as g } from "./index21.mjs";
const f = [
  "ads_source",
  "channel",
  "campaign_id",
  "gclid"
], v = (r, p) => {
  var _;
  const {
    items: o = [],
    gift_cards: i = [],
    customer: n = null,
    gift_card_code: s
  } = r, u = n ? c({
    ...n,
    phone: n ? n.country_code + n.phone_number : null
  }) : null;
  return f.forEach((e) => {
    const t = g(e);
    t && (r[e] = t);
  }), {
    ...c({
      payment_type: r.payment_type,
      redeem_gift_card: r.redeem_gift_card,
      client_voucher_id: r.client_voucher_id,
      ads_source: r.ads_source,
      channel: r.channel,
      campaign_id: r.campaign_id,
      gclid: r.gclid,
      opted_for_insurance: r.opted_for_insurance,
      customer_uuid: r.customer_uuid,
      payment: r.payment
    }),
    total_price: l({
      ...o.length && { cartItems: o },
      ...i.length && { giftCards: i },
      insurancePrice: r.opted_for_insurance ? p : void 0
    }),
    payment_type: r.payment_type || ((_ = r.payment) == null ? void 0 : _.payment_method) || d.AMENITIZ_PAY,
    customer: u,
    gift_card_code: s,
    ...o.length && {
      items: o.map((e) => ({
        room_id: e.roomId,
        arrival_date: m(e.arrivalDate),
        departure_date: m(e.departureDate),
        total_adults: e.totalAdults,
        total_children: e.totalChildren,
        pricing_type_id: e.pricingTypeId,
        promotion_id: e.promotionId,
        price: parseFloat(e.totalPrice).toString(),
        insurance_eligible: e.insuranceEligible,
        extras: [...e.mandatoryExtras, ...e.optionalExtras].map((t) => ({
          extra_id: t.id,
          amount_requested: t.amount
        }))
      }))
    },
    ...i.length && {
      gift_cards: i.map(({ id: e, recipient_details: t }) => ({
        id: e,
        recipient_details: t
      }))
    }
  };
};
export {
  f as ABOOST_VALUES,
  v as createCartPayload
};
